import type { ViewIds } from '@ardoq/api-types';
import { trackEvent } from 'tracking/tracking';

const trackUrlLinkClicked = (activeView: ViewIds | null) => {
  trackEvent('Clicked URL link', {
    activeView,
  });
};

export { trackUrlLinkClicked };
